module.exports = __webpack_public_path__ + "img/LogoLoading_circle02.0053a297.png";